//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchProductOffers } from '~/services/product';

var ProductOffersModal = () => import(
/* webpackMode: "eager" */
'~/components/molecules/Product/Modal/ProductOffersModal.vue');

export default {
  name: 'ProductOffers',
  components: {
    ProductOffersModal
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    offersTotal: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      showModal: false,
      modal: null,
      offers: null
    };
  },

  methods: {
    closeAction() {
      this.showModal = false;
      this.modal = null;
    },

    handleClick(event) {
      fetchProductOffers(this.$store, this.product.reference).then((_ref) => {
        var {
          offers
        } = _ref;
        this.offers = offers;
        this.modal = 'product-offers-modal';
        this.showModal = true;
        this.$root.$emit('generic-tracking', event, {
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_offres',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      });
    }

  }
};